import { WebappClassicWindow } from '@/types/classic';

/**
 * Library to track and resolve promises by key name
 *
 *
 * example:
 * DP.BootstrapPromise.get('MyEvent').then(() => console.log('MyEvent is resolved));
 * DP.BootstrapPromise.resolve('MyEvent');
 *
 * example2:
 * // can be called out of order
 * DP.BootstrapPromise.get('MyEvent').then(() => console.log('MyEvent is resolved));
 * DP.BootstrapPromise.resolve('MyEvent');
 *
 * example3:
 * // get returns a Promise, so you can use Promise.all
 * Promise.all([
 *  DP.BootstrapPromise.resolve('MyEvent'),
 *  DP.BootstrapPromise.resolve('MyEvent2')
 * ]).then(() => console.log('Both events are resolved'));
 *
 * @author Paul Aeria
 * @namespace
 */
export type BootstrapPromise = Promise<any>;
export type BootstrapPromiseMap = Record<string, BootstrapPromise>;

// TODO: fix types and remove @ts-ignore
export default function classicBootstrapPromiseInitialize(): WebappClassicWindow['DP']['BootstrapPromise'] {
  window.DP = window.DP || {};
  window.DP.BootstrapPromise =
    window.DP.BootstrapPromise ||
    (function() {
      const promiseMap: BootstrapPromiseMap = {};
      const resolveMap: BootstrapPromiseMap = {};

      function createNewPromise(name: string): BootstrapPromise {
        promiseMap[name] = new Promise(resolve => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          resolveMap[name] = resolve;
        });

        return promiseMap[name];
      }

      function get(name: string): BootstrapPromise {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (promiseMap[name]) {
          return promiseMap[name];
        }

        return createNewPromise(name);
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      function resolve(name: string, data: any): BootstrapPromise {
        if (!resolveMap[name]) {
          createNewPromise(name);
        }

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        resolveMap[name](data);
      }

      return {
        get,
        resolve,
        id: new Date().getTime(),
      };
    })();

  return window.DP.BootstrapPromise;
}
